var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "button",
        {
          on: {
            click: function($event) {
              return _vm.show(_vm.modalName)
            }
          }
        },
        [_vm._v("Read more")]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: _vm.modalName,
            classes: "textImageModal",
            height: "auto",
            scrollable: true
          }
        },
        [
          _c("h1", { domProps: { innerHTML: _vm._s(this.modalData.title) } }),
          _vm._v(" "),
          _c("h2", {
            domProps: { innerHTML: _vm._s(this.modalData.subtitle) }
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "description",
            domProps: { innerHTML: _vm._s(this.modalData.description) }
          }),
          _vm._v(" "),
          _vm.modalData.url
            ? _c(
                "a",
                { attrs: { href: this.modalData.url, target: "_blank" } },
                [_vm._v("Linkedin")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "buttonGroup" }, [
            _c(
              "button",
              {
                staticClass: "buttonClose",
                on: {
                  click: function($event) {
                    return _vm.hide(_vm.modalName)
                  }
                }
              },
              [_c("i", { staticClass: "fal fa-times" })]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }